import AdvSelectInput from "@builder/components/app/Settings/StoreData/AdvSelectInput";
import Customers from "@builder/components/app/Settings/StoreData/Customers";
import Orders from "@builder/components/app/Settings/StoreData/Orders";
import Products from "@builder/components/app/Settings/StoreData/Products";
import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { useMemo } from "react";
import Loader from "../../Loading/Loader";
import { FINAL_USERS, ORG_USERS, UserTypes } from "@builder/types/Users.type";
import { skipToken } from "@reduxjs/toolkit/query";
import { setStoreData } from "@builder/store/slices/storeDataSlice";
import { Company } from "@builder/types/Company.type";
import { useGetCompaniesByOrgQuery, useGetCompanyQuery } from "@builder/store/slices/dataApiSlices/companiesApiSlice";

const StoreData = () => {
    const dispatch = useAppDispatch();
    const { user, company, data: storeData } = useAppSelector(state => state.storeData);
    const activeCompany = storeData?.company;

    const companyCallback = (value: Company) => {
        dispatch(
            setStoreData({
                company: value
            })
        );
    };

    const isOrg = useMemo(() => {
        if (!user) return null;
        if (FINAL_USERS.includes(user?.type as UserTypes) || ORG_USERS.includes(user?.type as UserTypes)) {
            return true;
        }
        return false;
    }, [user]);

    const { data: companies, isLoading: companiesLoading } = useGetCompaniesByOrgQuery(isOrg && company?._id ? company._id : skipToken);
    const { data: realCompany, isLoading: realCompanyLoading } = useGetCompanyQuery(
        isOrg !== null && !isOrg && user?.companies?.[0] ? user?.companies?.[0].$oid : skipToken
    );
    const { data: demoCompany, isLoading: demoCompanyLoading } = useGetCompanyQuery(
        isOrg !== null && !isOrg && user?.companies?.[1] ? user?.companies?.[1].$oid : skipToken
    );

    const companiesArray = useMemo(() => {
        if (isOrg) {
            return companies;
        } else if (isOrg !== null) {
            return [realCompany, demoCompany].filter(Boolean) as Company[];
        }
        return [];
    }, [isOrg, companies, realCompany, demoCompany]);

    if (!activeCompany?._id) return null;

    return (
        <SidebarCollapse title="Store data" open>
            {companiesLoading || realCompanyLoading || demoCompanyLoading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Loader />
                </div>
            ) : (
                <>
                    <AdvSelectInput
                        value={activeCompany}
                        options={companiesArray || []}
                        inputValue=""
                        noSearch
                        label="Companies"
                        hasMore={false}
                        findLabel={option => {
                            return option.name || "";
                        }}
                        clickCallback={companyCallback}
                        scrollCallback={() => {}}
                        searchCallback={() => {}}
                    />
                    <Products companyId={activeCompany._id} organizationId={activeCompany.organizationId} isOrg={isOrg} />
                    <Orders companyId={activeCompany._id} organizationId={activeCompany.organizationId} isOrg={isOrg} />
                    <Customers companyId={activeCompany._id} organizationId={activeCompany.organizationId} isOrg={isOrg} />
                </>
            )}
        </SidebarCollapse>
    );
};

export default StoreData;
